<template>
  <b-container>
    <b-row class="align-items-center">
      <b-col>
        <h2 class="mb-0">Users</h2>
      </b-col>
      <b-col>
        <b-button class="float-right" variant="success" href="user/new"
          >Add User</b-button
        >
      </b-col>
    </b-row>
    <b-table
      class="mt-3"
      hover
      :fields="fields"
      :items="items"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      sort-icon-left
    >
      <template #cell(edit)="data">
        <b-button
          variant="primary"
          @click="$router.push(`/admin/user/${data.item.id}/edit`)"
          >Edit</b-button
        >
      </template>
      <template #cell(name_first)="data">
        {{ data.item.name_first + " " + data.item.name_last }}
      </template>
      <template #cell(opt_active)="data">
        <b-form-checkbox
          :checked="data.item.opt_active === 1"
          disabled
        ></b-form-checkbox>
      </template>
      <template #cell(opt_admin)="data">
        <b-form-checkbox
          :checked="data.item.opt_admin === 1"
          disabled
        ></b-form-checkbox>
      </template>
      <template #cell(opt_underwriter)="data">
        <b-form-checkbox
          :checked="data.item.opt_underwriter === 1"
          disabled
        ></b-form-checkbox>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import UserDataService from "@/services/UserDataService";

export default {
  data() {
    return {
      items: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        { key: "edit", label: "Edit" },
        { key: "name_first", label: "Name", sortable: true },
        { key: "opt_active", label: "Active" },
        { key: "opt_admin", label: "Admin" },
        { key: "opt_underwriter", label: "Underwriter" },
        { key: "email", label: "Email" },
      ],
    };
  },
  created() {
    UserDataService.getAllUsers()
      .then((res) => {
        this.items = res.data;
      })
      .catch((err) => {
        this.$emit("error", err);
      });
  },
};
</script>
